import BaseComponent from '@/components/base';
import { StyleCta } from '@/components/style/style-cta';
import { FontStyle } from '@/components/style';
import retailStyle, { Colors } from '@/components/retail-products/style';
import ShopifyAPI from '@/gateway/ShopifyAPI';
import RetailProductItem from '@/components/retail-products/retail-product-item';

export default class RetailProducts extends BaseComponent {
  static get observedAttributes() {
    return ['products'];
  }

  styleProperties = {};

  onConstruct() {
    this.backgroundColor = Colors.backgroundColor;
  }

  afterMount() {
    if (!this.products) return;

    const addVariantToCart = (product) => {
      const variants = product?.variants?.edges;
      const item = {
        id: variants ? variants[0].node.id.split('/').reverse()[0] : undefined,
        quantity: 1,
        properties: {
          __profile_type: 'hair'
        }
      };
      ShopifyAPI.addToCart({ items: [item] }).then((response) => {
        const { status = 0, error } = response;
        if (status !== 200) {
          this.errorModal.enabled = true;
        }

        this.querySelectorAll('modal-component').forEach((element) => {
          element.enabled = false;
        });
      });
    };

    const enableLoadingModal = () => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(
        ` <modal-component enabled="true" modal-width="366px" header-disabled="true" transparent="true" >
             <div style="width: 100%; display: flex; justify-content: center; align-items: center">
                <loader-component></loader-component>
            </div>
        </modal-component>`,
        'text/html'
      );
      const newElement = doc.body.firstChild;
      this.appendChild(newElement);
    };

    const allProductCards = this.shadowRoot.querySelectorAll('product-card');
    allProductCards.forEach((productCardElem) => {
      productCardElem.handleClick = () => {
        const productHandle = productCardElem.getAttribute('handle');
        const product = this.products.find(
          (product) => product.handle === productHandle
        );
        enableLoadingModal();
        addVariantToCart(product);
      };
    });
  }

  render() {
    return `
        ${retailStyle({
          isSmall: this.isSmall,
          backgroundColor: this.backgroundColor,
          ...this.styleProperties
        })}
        ${StyleCta}
        ${FontStyle}


      <div class="container">
        ${this.StepOneTitle()}
        ${this.StepOneProducts()}
        ${this.MiddleComponent()}
        ${this.StepTwoTitle()}
        ${this.StepTwoProducts()}
        <modal-component
          modal-width="366px"
          header-disabled="false"
          transparent="false"
          enabled="false"
        >
          There was an error adding the product to the cart. Please try again.
        </modal-component>
      </div>
    `;
  }

  StepOneTitle() {
    return `
      <div class="step-container">
            <div class="step-title title-font-5">${this.step1Title}</div>
            <div class="title-font-11 step-sub-title">
                ${this.step1SubTitle}
            </div>
        </div>
    `;
  }

  StepOneProducts() {
    const normalProducts = this.products
      .filter((x) => !x.handle.includes('goal'))
      .sort((a, b) => {
        if (this.isSmall) return a.position.mobile - b.position.mobile;
        return a.position.desktop - b.position.desktop;
      });

    return `
    <div class="products-container">
            ${normalProducts
              ?.map((x) =>
                RetailProductItem({
                  productData: x,
                  isSmall: this.isSmall,
                  ...this.styleProperties
                })
              )
              .join('')}
        </div>
    `;
  }

  StepTwoTitle() {
    return `
      <div class="step-container">
            <div class="step-title title-font-5">${this.step2Title}</div>
            <div class="title-font-11 step-sub-title">
                ${this.step2SubTitle}
            </div>
        </div>
    `;
  }

  StepTwoProducts() {
    const goalProducts = this.products
      .filter((x) => x.handle.includes('goal'))
      .sort((a, b) => a.goalPosition - b.goalPosition)
      .sort((a, b) => {
        if (a?.tags?.includes('bestseller') && b?.tags?.includes('bestseller'))
          return 0;
        if (a?.tags?.includes('bestseller')) return -1;
        return 1;
      });

    return `
    <div class="products-container">
            ${goalProducts
              ?.map((x) =>
                RetailProductItem({
                  productData: x,
                  isSmall: this.isSmall,
                  ...this.styleProperties
                })
              )
              .join('')}
        </div>
    `;
  }

  MiddleComponent() {
    return `<slot></slot>`;
  }

  get products() {
    return this.state['products'] || [];
  }

  set products(value) {
    this.setAttribute('products', JSON.stringify(value));
  }

  get middleText() {
    return this.getAttribute('middle-text') ?? '';
  }
  get middleImage() {
    return this.getAttribute('middle-image') ?? '';
  }
  get middleImageMobile() {
    return this.getAttribute('middle-image-mobile') ?? '';
  }
  get step1Title() {
    return this.getAttribute('step-1-title') ?? '';
  }
  get step1SubTitle() {
    return this.getAttribute('step-1-sub-title') ?? '';
  }

  get step2Title() {
    return this.getAttribute('step-2-title') ?? '';
  }

  get step2SubTitle() {
    return this.getAttribute('step-2-sub-title') ?? '';
  }

  get isLoading() {
    return this.getAttribute('is-loading') === 'true';
  }

  set isLoading(value) {
    this.setAttribute('is-loading', `${value}`);
  }

  get errorModal() {
    return this.shadowRoot.querySelector('modal-component');
  }
}
